export const TOAST_SUCCESS_BG = '#EDF7EE';
export const TOAST_FAIL_BG = '#FFF1F1';
